import { createContext, useEffect, useState, ReactNode } from "react";

interface Locale {
  value: string;
  label: string;
}

interface LocaleContextType {
  selectedLocale: Locale;
  setSelectedLocale: React.Dispatch<React.SetStateAction<Locale>>;
}

const defaultLocale: Locale = {
  value: "en",
  label: "English",
};

const LocaleContext = createContext<LocaleContextType>({
  selectedLocale: defaultLocale,
  setSelectedLocale: () => null,
});

interface LocaleProviderProps {
  children: ReactNode;
}

export const LocaleProvider: React.FC<LocaleProviderProps> = ({ children }) => {
  const [selectedLocale, setSelectedLocale] = useState<Locale>(() => {
    const stored = localStorage.getItem("locale");
    return stored ? JSON.parse(stored) : defaultLocale;
  });

  useEffect(() => {
    localStorage.setItem("locale", JSON.stringify(selectedLocale));
  }, [selectedLocale]);

  return (
    <LocaleContext.Provider value={{ selectedLocale, setSelectedLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};

export { LocaleContext };
